// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2rDs1","list":"styles_list__sne1K"};